import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Route({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Route</title>
      <path
        d="M10.5 12H17C18.6569 12 20 13.3431 20 15V15C20 16.6569 18.6569 18 17 18H8"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
      />
      <path
        d="M15 12L7 12C5.34315 12 4 10.6569 4 9V9C4 7.34314 5.34315 6 7 6L16 6"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
      />
      <circle cx="6" cy="18" r="2.25" stroke={color ?? 'currentColor'} strokeWidth="1.5" />
      <circle cx="18" cy="6" r="2.25" stroke={color ?? 'currentColor'} strokeWidth="1.5" />
    </svg>
  );
}
